import React from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Box, Stack } from '@mui/material';
import { IAudition } from '../../types/global/helper';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { CustomChipGroup } from '../Chip/CustomChipGroup';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { useDispatch } from 'react-redux';
import { navigate } from '../../redux/navigator/action';
import { replaceRouteParam } from '../../utils/routesProcessor';
import { ROUTES } from '../../types/global/routes.types';

interface IJobSuggestionCard {
    job: IAudition;
}

const JobSuggestionCard: React.FC<IJobSuggestionCard> = ({ job }) => {
    const { themeStyle } = useThemeContext();
    const dispatch = useDispatch();

    const handleGoToJob = () => {
        const route = replaceRouteParam(ROUTES.AUDITION_DETAIL, 'auditionId', job.slug!);
        dispatch(
            navigate({
                routes: route,
            }),
        );
    };
    return (
        <Stack my={2}>
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    color: theme[themeStyle].tag_white,
                    fontSize: 16,
                    mb: 1,
                }}>
                Featured Job
            </Typography>
            <Card sx={{ maxWidth: 400, borderRadius: 2, boxShadow: 3 }}>
                {/* Image at the top */}
                <CardMedia
                    component="img"
                    height="140"
                    image={job.imageCover} // Replace with your image URL
                    alt={`${job.title}_image`}
                />
                {/* Card Content */}
                <CardContent sx={{ backgroundColor: theme[themeStyle].secondaryBg }}>
                    <Box sx={{ display: 'flex', gap: 1, marginBottom: 1 }}>
                        {/* <Chip label="ONLINE COMMERCIAL / VIDEO AD" color="primary" size="small" />
                    <Chip label="PAID" color="success" size="small" />
                    <Chip label="NONUNION" color="default" size="small" /> */}
                        <CustomChipGroup tags={job.tags} maxVisible={3} clickable={false} withNiceColor />
                    </Box>
                    <Typography
                        variant="h6"
                        component="div"
                        fontWeight="bold"
                        sx={{
                            color: theme[themeStyle].tag_white,
                        }}>
                        {job.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        paragraph
                        sx={{
                            color: theme[themeStyle].tag_white,
                        }}>
                        {job.synopsis}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{
                            color: theme[themeStyle].tag_white,
                        }}>
                        ROLES HIRING FOR:
                    </Typography>
                    {job.roles &&
                        job.roles.map((role, editIndex) => (
                            <Typography
                                variant="body2"
                                key={editIndex}
                                color="text.primary"
                                sx={{
                                    color: theme[themeStyle].tag_white,
                                }}>
                                → {role.character} {job.min_age && job.min_age} {role.max_age && `- ${role.max_age}`}
                            </Typography>
                        ))}

                    {/** Text button example */}
                    <Button
                        variant="text"
                        size="small"
                        sx={{ marginTop: 1, textTransform: 'none' }}
                        color="primary"
                        onClick={handleGoToJob}>
                        View and apply
                    </Button>
                </CardContent>
            </Card>
        </Stack>
    );
};

export { JobSuggestionCard };
